module.exports = __webpack_public_path__ + "static/43-7eb837393dbda58166027d03aeb208a9.png";